import {Component, computed, OnDestroy, OnInit, Signal} from '@angular/core';
import {ContentComponent} from '../../../components/content/content.component';
import {CommonModule} from '@angular/common';
import {BreadcrumbsComponent} from '../../../common/breadcrumbs/breadcrumbs.component';
import {Store} from '@ngrx/store';
import {ActivatedRoute, Router, RouterModule} from '@angular/router';
import {ApplicationAppEntityApplicationRead, ServiceAppEntityServiceRead} from '../../../openapi';
import {selectApplication, selectLoading, selectPending} from '../../../store/selectors/application.selectors';
import {
  fakeSignApplication,
  loadApplication,
  loadPayments,
  loadServiceAttachmentPositions,
  sendApplication,
  setApplication,
  setPayments,
  signApplication
} from '../../../store/actions/application.actions';
import {selectServiceByUrl} from '../../../store/selectors/app.selectors';
import {SpinnerComponent} from '../../../common/spinner/spinner.component';
import {UploaderAttachmentsService} from '../../../services/uploader-attachments.service';
import {AlertContainerComponent, AlertService} from '../../../common/alert-container/alert-container.component';
import {ApplicationPreviewComponent} from '../application/common/application-preview/application-preview.component';
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-approved-preview-page',
  standalone: true,
  imports: [
    ContentComponent,
    BreadcrumbsComponent,
    RouterModule,
    CommonModule,
    SpinnerComponent,
    AlertContainerComponent,
    ApplicationPreviewComponent
  ],
  providers: [UploaderAttachmentsService],
  templateUrl: './approved-preview-page.component.html'
})
export class ApprovedPreviewPageComponent implements OnInit, OnDestroy {
  public applicationId: string | undefined =
    this.route.snapshot.params['appId'];

  public signStatus: 'success' | 'canceled' | string | undefined =
    this.route.snapshot.params['signStatus'];

  public application: Signal<ApplicationAppEntityApplicationRead | null> =
    this.store$.selectSignal(selectApplication);

  public showPaymentBtn: Signal<boolean> = computed(() => !!this.application()?.service?.serviceAttachmentPositions?.filter(v => !!v?.fee)?.length);

  public contentUrl: string | undefined = this.route.snapshot.params['contentUrl'];

  public serviceType: Signal<ServiceAppEntityServiceRead | null> =
    this.store$.selectSignal(
      selectServiceByUrl(this.contentUrl || '')
    );

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public readonly env = environment;

  constructor(
    private store$: Store,
    private route: ActivatedRoute,
    private router: Router,
    private uploaderService: UploaderAttachmentsService,
    private alertService: AlertService
  ) {
  }

  public fakeSign(): void {
    this.store$.dispatch(fakeSignApplication({
      applicationId: this.applicationId || '',
      successFnc: () => {
      },
      failureFnc: () => {
      }
    }));
  }

  public signApplication(): void {
    // to do
    // need to handle success or failure messages
    this.store$.dispatch(
      signApplication({
        applicationId: this.applicationId || '',
        successFnc: (redirectUrl: string) => {
          window.location.href = redirectUrl;
        },
        failureFnc: () => {
        }
      })
    );
  }

  public sendApplication(): void {
    this.store$.dispatch(sendApplication({
        applicationId: this.applicationId || '',
        successFnc: () => {
          this.router.navigate(
            ['/wnioski-wyslane' + this.application()?.service?.url, this.applicationId],
            {
              state: {message: 'applicationSent'}
            }
          );
        },
        failureFnc: () => {
        }
      })
    );
  }

  public onDownloadApplicationPdf(event: Event): void {
    const id = this.application()?.document?.id;
    const name = this.application()?.document?.originalName;
    event.preventDefault();
    event.stopPropagation();
    if (id && name) {
      this.uploaderService.downloadAttachment(id, name).toPromise().then();
    }
  }

  public onDownloadSignedApplication(event: Event): void {
    const id = this.application()?.signedDocument?.id;
    const name = this.application()?.signedDocument?.originalName;
    event.preventDefault();
    event.stopPropagation();
    if (id && name) {
      this.uploaderService.downloadAttachment(id, name).toPromise().then();
    }
  }

  private handleMessages(): void {
    if (!!history.state?.message) {
      this.alertService.showByApplicationCode(history.state.message);
    }
    if (this.signStatus === 'success') {
      this.alertService.showByApplicationCode('applicationSigned');
    }
    if (this.signStatus === 'canceled') {
      this.alertService.showByApplicationCode('applicationNotSigned');
    }
  }

  public ngOnInit(): void {
    this.handleMessages();

    this.store$.dispatch(loadApplication({id: this.applicationId || ''}));
    this.store$.dispatch(loadPayments({applicationId: this.applicationId || ''}));
    this.store$.dispatch(loadServiceAttachmentPositions({appId: this.applicationId || ''}));
  }

  public ngOnDestroy(): void {
    this.store$.dispatch(setApplication({application: null}));
    this.store$.dispatch(setPayments({applicationPayment: null}));
  }
}
